import * as React from "react";
const SvgTerminal = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 17.965a1.035 1.035 0 0 1 0 2.07h-8a1.035 1.035 0 0 1 0-2.07zM3.269 4.269a1.034 1.034 0 0 1 1.462 0l6 6a1.034 1.034 0 0 1 0 1.463l-6 6a1.034 1.034 0 1 1-1.462-1.463L8.537 11 3.27 5.731a1.034 1.034 0 0 1 0-1.462"
}));
export default SvgTerminal;
//# sourceMappingURL=Terminal.js.map